import { SectionType } from '../validationSchemas/ReportTemplateSchema';

const reportTemplateColumnListUnindexed = [
  {
    'Column ID': 'report_month',
    'Column Label': 'Month',
    Category: 'Dimensions',
    Subcategory: 'Date Grouping',
  },
  {
    'Column ID': 'report_day',
    'Column Label': 'Date',
    Category: 'Dimensions',
    Subcategory: 'Date Grouping',
  },
  {
    'Column ID': 'week_start',
    'Column Label': 'Week Start',
    Category: 'Dimensions',
    Subcategory: 'Date Grouping',
  },
  {
    'Column ID': 'advertiser_name',
    'Column Label': 'Advertiser',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'client_name',
    'Column Label': 'Agency',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_name',
    'Column Label': 'Campaign Name',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_start_date',
    'Column Label': 'Campaign Start Date',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_end_date',
    'Column Label': 'Campaign End Date',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_days_left',
    'Column Label': 'Days Left',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_cpm',
    'Column Label': 'Campaign Rate',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'data_through',
    'Column Label': 'Report Through',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_imp_budget',
    'Column Label': 'Paid Impression Budget',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'contract_dollar_budget',
    'Column Label': 'Total Dollar Budget',
    Category: 'Dimensions',
    Subcategory: 'Campaign',
  },
  {
    'Column ID': 'io_name',
    'Column Label': 'Line Item Name',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'io_start_date',
    'Column Label': 'Line Item Start Date',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'io_end_date',
    'Column Label': 'Line Item End Date',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'io_days_left',
    'Column Label': 'Line Item Days Left',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'io_imp_budget',
    'Column Label': 'Impression Budget',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'io_dollar_budget',
    'Column Label': 'Dollar Budget',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'adjusted_pricing_rate',
    'Column Label': 'Pricing Rate',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'pricing_model',
    'Column Label': 'Pricing Model',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'media_type',
    'Column Label': 'Media Type',
    Category: 'Dimensions',
    Subcategory: 'Line Item',
  },
  {
    'Column ID': 'cost_plus_max_dollar_budget',
    'Column Label': 'Max Dollar Budget',
    Category: 'Dimensions',
    Subcategory: 'Cost Plus',
  },
  {
    'Column ID': 'cost_plus_max_cpm',
    'Column Label': 'Max CPM',
    Category: 'Dimensions',
    Subcategory: 'Cost Plus',
  },
  {
    'Column ID': 'cost_plus_cpm',
    'Column Label': 'eCPM',
    Category: 'Dimensions',
    Subcategory: 'Cost Plus',
  },
  {
    'Column ID': 'cost_plus_max_io_budget',
    'Column Label': 'Line Item Max Dollar Budget',
    Category: 'Dimensions',
    Subcategory: 'Cost Plus',
  },
  {
    'Column ID': 'cost_plus_io_max_cpm',
    'Column Label': 'Line Item Max CPM',
    Category: 'Dimensions',
    Subcategory: 'Cost Plus',
  },
  {
    'Column ID': 'creative_name',
    'Column Label': 'Creative',
    Category: 'Dimensions',
    Subcategory: 'Creative',
  },
  {
    'Column ID': 'creative_size',
    'Column Label': 'Size',
    Category: 'Dimensions',
    Subcategory: 'Creative',
  },
  {
    'Column ID': 'location_name',
    'Column Label': 'Location Name',
    Category: 'Dimensions',
    Subcategory: 'Location',
    Tooltip: 'Select only one per section',
  },
  {
    'Column ID': 'state_name',
    'Column Label': 'State/Province',
    Category: 'Dimensions',
    Subcategory: 'Location',
    Tooltip: 'Select only one per section',
  },
  {
    'Column ID': 'city_name',
    'Column Label': 'City',
    Category: 'Dimensions',
    Subcategory: 'Location',
    Tooltip: 'Select only one per section',
  },
  {
    'Column ID': 'postal_code',
    'Column Label': 'Postal Code',
    Category: 'Dimensions',
    Subcategory: 'Location',
    Tooltip: 'Select only one per section',
  },
  {
    'Column ID': 'dma_name',
    'Column Label': 'Nielsen DMA',
    Category: 'Dimensions',
    Subcategory: 'Location',
    Tooltip: 'Select only one per section',
  },
  {
    'Column ID': 'pricing_rate',
    'Column Label': 'Pricing Rate',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'pricing_model',
    'Column Label': 'Pricing Model',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'total_impression_budget',
    'Column Label': 'Total Impression Budget',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'total_dollar_budget',
    'Column Label': 'Total Dollar Budget',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'cost_plus_cpm',
    'Column Label': 'Cost Plus eCPM',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'cost_plus_max_cpm',
    'Column Label': 'Cost Plus Max CPM',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'cost_plus_max_dollar_budget',
    'Column Label': 'Cost Plus Max Budget',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'contract_name',
    'Column Label': 'Campaign Name',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'media_type',
    'Column Label': 'Media Type',
    Category: 'Dimensions',
    Subcategory: 'Media Type',
  },
  {
    'Column ID': 'impressions',
    'Column Label': 'Impressions',
    Category: 'Metrics',
    Subcategory: 'Standard',
  },
  {
    'Column ID': 'clicks',
    'Column Label': 'Clicks',
    Category: 'Metrics',
    Subcategory: 'Standard',
  },
  {
    'Column ID': 'ctr',
    'Column Label': 'CTR',
    Category: 'Metrics',
    Subcategory: 'Standard',
  },
  {
    'Column ID': 'investment_to_date',
    'Column Label': 'Spend',
    Category: 'Metrics',
    Subcategory: 'Standard',
  },
  {
    'Column ID': 'delivery_percent',
    'Column Label': 'Delivery %',
    Category: 'Metrics',
    Subcategory: 'Delivery',
    Tooltip: 'Not calculated when selecting creative dimensions',
  },
  {
    'Column ID': 'remaining_impressions',
    'Column Label': 'Remaining Impressions',
    Category: 'Metrics',
    Subcategory: 'Delivery',
    Tooltip: 'Not calculated when selecting creative dimensions',
  },
  {
    'Column ID': 'remaining_budget',
    'Column Label': 'Remaining Budget',
    Category: 'Metrics',
    Subcategory: 'Delivery',
    Tooltip: 'Not calculated when selecting creative dimensions',
  },
  {
    'Column ID': 'conversions',
    'Column Label': 'Conversions',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'conversion_rate',
    'Column Label': 'Conversion Rate',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'pccr',
    'Column Label': 'PCCR',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'drives',
    'Column Label': 'Drives',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'calls',
    'Column Label': 'Calls',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'urls',
    'Column Label': 'URLs',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'other',
    'Column Label': 'Other',
    Category: 'Metrics',
    Subcategory: 'Conversions',
  },
  {
    'Column ID': 'video_start',
    'Column Label': 'Video Start',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_firstquartile',
    'Column Label': 'Video First Quartile',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_first_percent',
    'Column Label': 'Video First Quartile %',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_midpoint',
    'Column Label': 'Video Midpoint',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_midpoint_percent',
    'Column Label': 'Video Midpoint %',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_thirdquartile',
    'Column Label': 'Video Third Quartile',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_third_percent',
    'Column Label': 'Video Third Quartile %',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_complete',
    'Column Label': 'Video Complete',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'video_complete_percent',
    'Column Label': 'Video Complete %',
    Category: 'Metrics',
    Subcategory: 'Video',
  },
  {
    'Column ID': 'dcm_impressions',
    'Column Label': 'Impressions (DCM)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dcm_clicks',
    'Column Label': 'Clicks (DCM)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dcm_ctr',
    'Column Label': 'CTR (DCM)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dcm_discrepancy',
    'Column Label': 'Discrepancy (DCM)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dcm_third_party_spend',
    'Column Label': '3P Spend (DCM)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ft_impressions',
    'Column Label': 'Impressions (Flashtalking)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ft_clicks',
    'Column Label': 'Clicks (Flashtalking)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ft_ctr',
    'Column Label': 'CTR (Flashtalking)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ft_discrepancy',
    'Column Label': 'Discrepancy (Flashtalking)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ft_third_party_spend',
    'Column Label': '3P Spend (Flashtalking)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_monitored_ads',
    'Column Label': 'DV Monitored Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_fraud_sivt_free_ads',
    'Column Label': 'DV Fraud/SIVT Free Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_fraud_free_percent',
    'Column Label': 'DV Fraud Free %',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_measured_impressions',
    'Column Label': 'DV Display Measured Impressions',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_viewable_impressions',
    'Column Label': 'DV Display Viewable Impressions',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_viewability_rate',
    'Column Label': 'DV Viewability Rate',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_brand_safe_ads',
    'Column Label': 'DV Brand Safe Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_brand_safe_percent',
    'Column Label': 'DV Brand Safe %',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_brand_suitable_ads',
    'Column Label': 'DV Brand Suitable Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_brand_suitability_percent',
    'Column Label': 'DV Brand Suitability %',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'dv_groupm_billable_impressions',
    'Column Label': 'DV GroupM Payable Impressions',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_eligible_ivt_ads',
    'Column Label': 'IAS Eligible IVT Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_total_tracked_ads',
    'Column Label': 'IAS Total Tracked Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_valid_traffic',
    'Column Label': 'IAS Valid Traffic',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_ivt_free_rate',
    'Column Label': 'IAS IVT Free Rate',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_measured_ads',
    'Column Label': 'IAS Measured Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_viewable_impressions',
    'Column Label': 'IAS Viewable Impressions',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_viewability',
    'Column Label': 'IAS Viewability',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_passed_ads',
    'Column Label': 'IAS Passed Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_eligible_ads_brand_safety',
    'Column Label': 'IAS Eligible Ads Brand Safety',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_brand_safety_rate',
    'Column Label': 'IAS Brand Safety Rate',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_brand_suitability_failed_ads',
    'Column Label': 'IAS Brand Suitability Failed Ads',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'ias_brand_suitability_rate',
    'Column Label': 'IAS Brand Suitability Rate',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'innovid_impressions',
    'Column Label': 'Impressions (Innovid)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'innovid_clicks',
    'Column Label': 'Clicks (Innovid)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'innovid_ctr',
    'Column Label': 'CTR (Innovid)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'innovid_ctr_discrepancy',
    'Column Label': 'CTR Discrepancy (Innovid)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'innovid_discrepancy',
    'Column Label': 'Discrepancy (Innovid)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
  {
    'Column ID': 'innovid_third_party_spend',
    'Column Label': '3P Spend (Innovid)',
    Category: 'Metrics',
    Subcategory: 'Third Party',
  },
];

const reportTemplateColumnList = reportTemplateColumnListUnindexed.map((item, index) => ({ ...item, key: index }));

export const enabledSubcategoriesBySectionType = {
  [SectionType.FirstParty]: {
    Dimensions: ['Date Grouping', 'Campaign', 'Line Item', 'Cost Plus', 'Creative'],
    Metrics: ['Standard', 'Delivery', 'Conversions', 'Video'],
  },
  [SectionType.ThirdParty]: {
    Dimensions: ['Date Grouping', 'Campaign', 'Line Item', 'Cost Plus'],
    Metrics: ['Standard', 'Delivery', 'Conversions', 'Video', 'Third Party'],
  },
  [SectionType.Location]: {
    Dimensions: ['Campaign', 'Line Item', 'Location'],
    Metrics: ['Standard', 'Conversions', 'Video'],
  },
  [SectionType.MediaType]: {
    Dimensions: ['Media Type'],
    Metrics: ['Standard', 'Delivery', 'Conversions', 'Video', 'Third Party'],
  },
};

export const getLocationsColumns = () =>
  reportTemplateColumnList.filter((column) => column.Category === 'Dimensions' && column.Subcategory === 'Location');

export const getColumnLabelById = (columnId) =>
  reportTemplateColumnList.find((column) => column['Column ID'] === columnId)?.['Column Label'];

const enabledSectionTypeBySubcategories = {};

Object.entries(enabledSubcategoriesBySectionType).forEach(([sectionTypeItem, categories]) => {
  Object.entries(categories).forEach(([category, subcategoryList]) => {
    subcategoryList.forEach((subcategory) => {
      if (!enabledSectionTypeBySubcategories[category]) {
        enabledSectionTypeBySubcategories[category] = {};
      }

      if (!enabledSectionTypeBySubcategories[category][subcategory]) {
        enabledSectionTypeBySubcategories[category][subcategory] = [];
      }

      enabledSectionTypeBySubcategories[category][subcategory].push(sectionTypeItem);
    });
  });
});

const columnIdsBySectionType = {};
Object.entries(enabledSubcategoriesBySectionType).forEach(([sectionTypeItem, categories]) => {
  if (!columnIdsBySectionType[sectionTypeItem]) {
    columnIdsBySectionType[sectionTypeItem] = [];
  }
  Object.entries(categories).forEach(([category, subcategoryList]) => {
    subcategoryList.forEach((subcategory) => {
      columnIdsBySectionType[sectionTypeItem] = columnIdsBySectionType[sectionTypeItem].concat(
        reportTemplateColumnList
          .filter((columnItem) => columnItem.Category === category && columnItem.Subcategory === subcategory)
          .map((columnItem) => columnItem['Column ID'])
      );
    });
  });
});

const getSectionTypesByCategoryAndSubcategory = (category, subcategory) =>
  enabledSectionTypeBySubcategories[category][subcategory];

export const filterColumnsByColumnIdsAndSectionType = (columnIds, sectionType) =>
  reportTemplateColumnList
    .filter(
      (column) =>
        columnIdsBySectionType[sectionType].includes(column['Column ID']) &&
        columnIds.includes(column['Column ID']) &&
        getSectionTypesByCategoryAndSubcategory(column.Category, column.Subcategory).includes(sectionType)
    )
    .map((column) => ({
      key: column.key,
      id: column['Column ID'],
      label: column['Column Label'],
      category: column.Category,
      subcategory: column.Subcategory,
      index: columnIds.indexOf(column['Column ID']),
    }))
    .sort((a, b) => {
      if (a.index < b.index) {
        return -1;
      }
      if (a.index > b.index) {
        return 1;
      }
      return 0;
    });

export const getColumnsBySectionTypeAndFilter = (sectionType, filter) => {
  const returnValue = {};

  reportTemplateColumnList.forEach((row) => {
    const label = row['Column Label'];
    const lowerCaseFilter = filter.toLowerCase();
    if (!filter || (filter !== '' && label.toLowerCase().indexOf(lowerCaseFilter) >= 0)) {
      if (!returnValue[row.Category]) {
        returnValue[row.Category] = {
          count: 0,
          subcategories: {},
        };
      }

      const sectionTypes = getSectionTypesByCategoryAndSubcategory(row.Category, row.Subcategory);

      if (!returnValue[row.Category].subcategories[row.Subcategory]) {
        returnValue[row.Category].subcategories[row.Subcategory] = {
          columns: [],
          enabled: sectionTypes?.includes(sectionType),
          sectionTypes,
        };
      }

      const column = {
        id: row['Column ID'],
        label: row['Column Label'],
        sectionTypes,
        tooltip: row.Tooltip,
      };

      returnValue[row.Category].subcategories[row.Subcategory].columns.push(column);
      returnValue[row.Category].count += 1;
    }
  });

  return returnValue;
};

export default reportTemplateColumnList;
